const initialState = [];

export default function reducer(state = initialState, action) {

	if (action.type === 'MY_KEYWORD_SET') {
		let newState = Object.assign([], state);
		newState = action.payload;
		return newState;
	}

	else {
		return state;
	}
}
